<template>
    <div>
        <!-- tabs -->
        <v-tabs v-model="tab" show-arrows height="35">
            <v-tab
                class="text-capitalize "
                :to="{ 
                    name: 'administrative-weekly-report',
                    query: {
                        employeeId: $route.query.employeeId
                    }
                }"
            >
                {{$t('AdministrativeReport.reports')}}
            </v-tab>

            <v-tab
                v-if="!firstLevel"
                class="text-capitalize "
                :to="{ 
                    name: 'administrative-double-visits',
                    query: {
                        employeeId: $route.query.employeeId
                    }
                }"
            >
                {{$t('AdministrativeReport.double-visits')}}
            </v-tab>

            <v-tab
                class="text-capitalize "
                :to="{ 
                    name: 'administrative-visits',
                    query: {
                        employeeId: $route.query.employeeId
                    }
                }"
            >
                {{$t('AdministrativeReport.visits')}}
            </v-tab>

            <v-tab
                class="text-capitalize "
                :to="{ 
                    name: 'debt-record-visits'
                }"
            >
                {{$t('AdministrativeReport.debts')}}
            </v-tab>
            <v-tabs-slider color="primary"></v-tabs-slider>
        </v-tabs>
        <v-divider v-if="!$route.query.preview" class="mb-2"/>

         <!-- child page -->
        <loader v-if="loading"/>
        <router-view v-else/>
    </div>
</template>
<script>
import { firstLevel } from '@/configs/global.config'
export default {
    data() {
        return {
            tab: 0,
            loading: false,
            firstLevel
        }
    }
}
</script>
